import { postUser } from './api';
import { FormValues, toCreateDto } from './form';

export async function createNewUser(formData: FormValues) {
  const dto = toCreateDto(formData);
  return postUser(dto);
}